export default {"src":"/_next/static/media/Group_1.7f37169d.svg","height":163,"width":130,"blurWidth":0,"blurHeight":0};